module.exports = __webpack_public_path__ + "static/index/img/baikal-105.37aae39c.jpg";